import { render, staticRenderFns } from "./CustomGridBtnsTemplate.vue?vue&type=template&id=3e58cf72&"
import script from "./CustomGridBtnsTemplate.vue?vue&type=script&lang=js&"
export * from "./CustomGridBtnsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports